module.exports = __webpack_public_path__ + "static/img/2.eb57fa1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/internationalBrand/hnweR410A/2.jpg
// module id = jFQe
// module chunks = 1